/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantAndConfigs } from '../../models/tenant-and-configs';

export interface GetTenantByDomain$Params {

/**
 * domain of the tenant
 */
  tenant_domain: string;
}

export function getTenantByDomain(http: HttpClient, rootUrl: string, params: GetTenantByDomain$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantAndConfigs>> {
  const rb = new RequestBuilder(rootUrl, getTenantByDomain.PATH, 'get');
  if (params) {
    rb.query('tenant_domain', params.tenant_domain, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantAndConfigs>;
    })
  );
}

getTenantByDomain.PATH = '/api/v1/tenants/config';
